import React from "react";
import {
    Dialog, DialogTitle, DialogContent, DialogActions,
    Box, Typography, Avatar, IconButton, Button, Alert, CircularProgress,
} from "@mui/material";
import InventoryIcon from "@mui/icons-material/Inventory";
import DeleteIcon from "@mui/icons-material/Delete";
import CloseIcon from "@mui/icons-material/Close";
import WarningAmberIcon from "@mui/icons-material/WarningAmber";

const DeleteProductDialog = ({ open, onClose, onConfirm, deleting, product }) => {
    if (!product) return null;

    return (
        <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth
            PaperProps={{ sx: { borderRadius: 3 } }}>
            <DialogTitle sx={{ borderBottom: "2px solid #f1f3f5", px: 3, py: 2, display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                <Box display="flex" alignItems="center" gap={1}>
                    <Avatar sx={{ width: 32, height: 32, bgcolor: "#fef2f2" }}>
                        <WarningAmberIcon sx={{ fontSize: 18, color: "#DC2626" }} />
                    </Avatar>
                    <Typography variant="h6" fontFamily="Montserrat, sans-serif" fontWeight={700} color="#1a1a2e" fontSize={16}>
                        Supprimer le Produit
                    </Typography>
                </Box>
                <IconButton onClick={onClose} size="small" disabled={deleting}><CloseIcon /></IconButton>
            </DialogTitle>

            <DialogContent sx={{ pt: "24px !important", px: 3, pb: 2 }}>
                <Alert severity="warning" sx={{ borderRadius: 2, mb: 2 }}>
                    Cette action est <strong>irréversible</strong>. Le produit sera définitivement supprimé.
                </Alert>
                <Typography fontSize={14} fontFamily="Montserrat, sans-serif" color="#1a1a2e">
                    Voulez-vous vraiment supprimer le produit{" "}
                    <strong>« {product.name} »</strong> ?
                </Typography>
                <Typography fontSize={12} color="text.secondary" mt={1}>
                    Note : la suppression échouera si ce produit est encore associé à des récompenses. Détachez-le d'abord.
                </Typography>
            </DialogContent>

            <DialogActions sx={{ px: 3, py: 2, borderTop: "1px solid #e0e0e0", gap: 1 }}>
                <Button onClick={onClose} disabled={deleting}
                    sx={{ color: "text.secondary", textTransform: "none" }}>
                    Annuler
                </Button>
                <Button variant="contained" onClick={onConfirm} disabled={deleting}
                    startIcon={deleting ? <CircularProgress size={16} color="inherit" /> : <DeleteIcon />}
                    sx={{ bgcolor: "#DC2626", "&:hover": { bgcolor: "#b91c1c" }, color: "#fff", textTransform: "none", borderRadius: 2, fontWeight: 600, px: 3 }}>
                    {deleting ? "Suppression..." : "Supprimer"}
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default DeleteProductDialog;
